import { mapActions, mapGetters, mapMutations } from 'vuex';
import { maxLength, minLength, required, sameAs } from 'vuelidate/lib/validators';
import validation from '@/mixins/validation';
import IconEyeClose from '@/components/icons/IconEyeClose.vue';
import IconEye from '@/components/icons/IconEye.vue';

export default {
  name: 'restore',
  components: { IconEye, IconEyeClose },
  data() {
    return {
      isShowEmailFlow: true,
      isShowPassword: false,
      isShowPasswordConfirmation: false,
      payload: {
        password: '',
        password_confirmation: '',
        token: this.$route.query.token,
        email: this.$route.query.email,
        code: null,
        phone: null
      },
      validationErrors: {}
    };
  },
  mixins: [validation],
  validations() {
    let payload = {
      password: { required, minLength: minLength(8), maxLength: maxLength(120) },
      password_confirmation: { required, minLength: minLength(8), sameAsPassword: sameAs('password') }
    };

    if (!this.isShowEmailFlow) {
      payload.code = { required, minLength: minLength(6) };
    }

    return { payload };
  },
  created() {
    document.getElementById('html').classList.add('hide');
    if (this.modalData['restore'] && this.modalData['restore'].type === 'phone') {
      this.payload.phone = this.modalData['restore'].phone;
      this.isShowEmailFlow = false;
    }
  },
  watch: {
    'payload.password': function () {
      this.$v.$reset();
    },
    'payload.password_confirmation': function () {
      this.$v.$reset();
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'auth/isLoading',
      modalData: 'app/modalData'
    }),
    passwordErrors() {
      return this.computeErrors('payload', 'password', {
        maxLength: { message: 'validation.maxLength', options: { size: 120 } },
        required: 'validation.required',
        minLength: { message: 'validation.minLength', options: { size: 8 } }
      });
    },
    passwordConfirmationErrors() {
      return this.computeErrors('payload', 'password_confirmation', {
        required: 'validation.required',
        sameAsPassword: 'validation.sameAs',
        minLength: { message: 'validation.minLength', options: { size: 8 } }
      });
    },
    codeErrors() {
      return this.computeErrors('payload', 'code', {
        required: 'validation.required',
        minLength: { message: 'validation.minLength', options: { size: 6 } }
      });
    }
  },

  methods: {
    ...mapMutations({
      modalClose: 'app/MODAL_CLOSE'
    }),
    ...mapActions({
      restorePasswordEmail: 'auth/RESTORE_PASSWORD_EMAIL',
      restorePasswordPhone: 'auth/RESTORE_PASSWORD_PHONE'
    }),
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      let { password, password_confirmation, email, token, code, phone } = this.payload;

      let payload = {
        password,
        password_confirmation,
        ...(this.isShowEmailFlow ? { email, token } : { code, phone })
      };

      let restoreMethod = this.isShowEmailFlow ? this.restorePasswordEmail : this.restorePasswordPhone;

      restoreMethod(payload)
        .then(() => {
          this.$toasted.success(this.$t('successRestorePassword'));

          if (this.isShowEmailFlow) {
            this.$router.replace({ query: null }).catch(() => {});
          }

          this.modalClose('restore');
          window.location.reload();
        })
        .catch((error) => {
          this.$toasted.error(error?.data?.message || this.$t('error.default'));
        });
    }
  }
};
